module.exports = __webpack_public_path__ + "9d0240dcdb4436104876325a65e1aa2c.png";